// Static icon registry — importing by name keeps lucide-react fully tree-shaken
// (a namespace import would bundle all ~1,400 icons into the main chunk).
import {
    Brain, Cloud, ShieldCheck, Laptop, Server, Compass, HeartPulse, Banknote, Factory, Landmark,
    ShoppingBag, Briefcase, Cpu, GraduationCap, Circle, Network, Database, Activity, Layers, Bot,
    AppWindow, FileCheck, Search, Wrench, ArrowRightLeft, Gauge, Settings, Fingerprint, Radar, Zap,
    Users, Headphones, Monitor, Workflow, Map, Rocket, Scale,
} from "lucide-react";

const ICONS = {
    Brain, Cloud, ShieldCheck, Laptop, Server, Compass, HeartPulse, Banknote, Factory, Landmark,
    ShoppingBag, Briefcase, Cpu, GraduationCap, Network, Database, Activity, Layers, Bot,
    AppWindow, FileCheck, Search, Wrench, ArrowRightLeft, Gauge, Settings, Fingerprint, Radar, Zap,
    Users, Headphones, Monitor, Workflow, Map, Rocket, Scale,
};

export const iconByName = (name) => ICONS[name] || Circle;
